import { css } from 'styled-components';
// eslint-disable-next-line import/no-namespace
import * as ss from 'styled-system';

import { fontWeights, linkStyles, transition } from 'theme';

export const buttonSize = (props: {
  fontSize?: string | number;
  p?: string | number;
  size?: 'tiny' | 'small' | 'medium' | 'large';
}) => {
  switch (props.size) {
    case 'tiny':
      return {
        fontSize: props.fontSize || '12px',
        padding: props.p ? undefined : '0 4px',
      };

    case 'small':
      return {
        fontSize: props.fontSize || '14px',
        padding: props.p ? undefined : '0.4em 1.2em',
      };

    case 'large':
      return {
        fontSize: props.fontSize || '18px',
        padding: props.p ? undefined : '12px 24px',
      };

    default:
      return {
        fontSize: props.fontSize || '16px',
        padding: props.p ? undefined : '8px 16px',
      };
  }
};

export const buttonStylesMinimal = `
  -webkit-font-smoothing: antialiased;
  display: inline-block;
  text-decoration: none;
  font-family: inherit;
  cursor: pointer;
  transition: all ${transition};
  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

export const linkAppearance = linkStyles;

export const buttonAppearance = `
  border-radius: 8px;
  font-weight: ${fontWeights.normal};
  letter-spacing: 0.5px;
  line-height: 1.25;
  text-align: center;
  vertical-align: middle;
`;

export const buttonStyles = css<{
  fontSize: string | number;
  p: string | number;
  size?: 'small' | 'medium' | 'large';
}>`
  ${buttonStylesMinimal}
  ${buttonAppearance}
  ${buttonSize}
  ${ss.borderRadius}
  ${ss.boxShadow}
`;
